import { DateLocalizer } from 'react-big-calendar';
import { PRINT_TIME_FORMAT, printDate, printTime } from '@guryou/utils';
import 'moment/locale/it';
import * as dates from './dates';
const dateRangeFormat = ({
  start,
  end
}) => `${printDate(start)} - ${printDate(end)}`;
const timeRangeFormat = ({
  start,
  end
}) => `${printTime(start)} - ${printTime(end)}`;
const timeRangeStartFormat = ({
  start
}) => `${printTime(start)} - `;
const timeRangeEndFormat = ({
  end
}) => ` - ${printTime(end)}`;
const weekRangeFormat = ({
  start,
  end
}, culture, local) => `${local.format(start, 'MMMM DD', culture)} – ${local.format(end, dates.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture)}`;
export const formats = {
  dateFormat: 'DD',
  dayFormat: 'DD ddd',
  weekdayFormat: 'ddd',
  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,
  timeGutterFormat: PRINT_TIME_FORMAT,
  monthHeaderFormat: 'MMMM YYYY',
  dayHeaderFormat: 'dddd MMM DD',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,
  agendaDateFormat: 'ddd MMM DD',
  agendaTimeFormat: PRINT_TIME_FORMAT,
  agendaTimeRangeFormat: timeRangeFormat
};
const gyLocalizer = moment => {
  const locale = (m, c) => c ? m.locale(c) : m;
  return new DateLocalizer({
    formats,
    firstOfWeek: () => 1,
    format: (value, format, culture) => locale(moment(value), culture).format(format)
  });
};
export default gyLocalizer;